import styled from 'styled-components';

interface UserImgStyleProps {
	width: number;
	outlineColor?: string;
	offset?: number;
	nameSize?: number;
	emailSize?: number;
	margin?: string;
}

export const UserImg = styled.div<UserImgStyleProps>`
	display: flex;
	gap: 1em;
	align-items: flex-end;
	margin-top: -1em;
	.user-content {
		transform: translate(0px, 6px);
	}
	.user-name {
		font-size: 1.5px;
		font-family: Manrope-Bold !important;
		text-align: left;
		@media (max-width: 1450px) {
			font-size: 1.25em;
		}
	}
	.user-slogan {
		font-size: 1.125em;
		text-align: left;
		font-family: Manrope-Medium !important;
		color: #808080;
		@media (max-width: 1450px) {
			font-size: 0.8125em;
		}
	}
	.dropdownAvatar {
		width: ${(props) => `${props.width * 0.06}em!important`};
		height: ${(props) => `${props.width * 0.06}em!important`};
		/* @media (max-width: 1450px) {
			width: ${(props) => 0.8 * props.width + 'px !important'};
			height: ${(props) => 0.8 * props.width + 'px !important'};
		} */
		margin: 0;
		border-radius: 50%;
		outline: solid #fff0;

		/* outline: 1px solid ${(props) => props.outlineColor}; */
		outline-offset: ${(props) => `${props.offset}px`};
		box-shadow: 0 0 0 3px ${(props) => props.outlineColor};
		overflow: hidden;
		position: relative;
	}
	.changeIcon {
		cursor: pointer !important ;
		/* @media (max-width: 1366px) {
			top: 90px;
			left: 90px;
		} */
	}
	.fileInput {
		opacity: 0;
		position: absolute;
		width: 1.8em;
		top: 0;
		z-index: 2;
		cursor: pointer;
	}
	.userInfo {
		width: 70%;
		.name {
			line-height: 1.04;
			font-size: ${(props) => `${props.nameSize && props.nameSize * 0.0625}em`};
			font-family: Manrope-Bold !important;
			color: #1e1e1e;
		}
		.email {
			font-size: ${(props) => `${props.emailSize && props.emailSize * 0.0625}em`};
			font-family: Manrope-Medium !important;
			color: #afafaf;
			line-height: unset;
		}
	}
`;
export const UploadImgContainer = styled.div`
	position: absolute;
	left: 7.5em;

	input,
	img {
		position: absolute;
	}
	img {
		position: relative;
		cursor: pointer;
		z-index: 1;
		width: 1.8em;
		height: auto;
		padding: 5px;
		border-radius: 50%;
		background-color: white;
		/* box-shadow: 2px 2px 2px 2px #1e1e1e1a; */
		border: 1px solid #1e1e1e1a;
	}
`;
